module.exports = __webpack_public_path__ + "media/images/logo-cfa1e49dc1c8601f03ea1d91d94b397b.png";